module.exports = __webpack_public_path__ + "static/media/Available-in-usa.a0f50bd1.png";